module.exports = __webpack_public_path__ + "assets/img/Ober_001.24464a86.jpg";